// extracted by mini-css-extract-plugin
export default {"toggle":"LanguageToggle_toggle__1btZE","option":"LanguageToggle_option__6yOgW","active":"LanguageToggle_active__gg1-F","separator":"LanguageToggle_separator__JDK4r"};